import { CreateAttachmentDependencies } from './createAttachment';
import { AttachmentState, stopFakeProgressIndicator } from 'owa-attachment-full-data';
import { ClientAttachmentId, ClientItemId } from 'owa-client-ids';
import AttachmentInfoResponseMessage from 'owa-service/lib/contract/AttachmentInfoResponseMessage';
import AttachmentResultCode from 'owa-service/lib/contract/AttachmentResultCode';
import AttachmentType from 'owa-service/lib/contract/AttachmentType';
import CreateAttachmentNotificationPayload from 'owa-service/lib/contract/CreateAttachmentNotificationPayload';
import NotificationPayloadBase from 'owa-service/lib/contract/NotificationPayloadBase';
import * as trace from 'owa-trace';
import { action } from 'satcheljs/lib/legacy';
import {
    onAttachmentCreationError,
    onAttachmentCreationSuccess,
} from './helpers/onAttachmentCreationHandlers';

export default action('handleCreateAttachmentNotification')(
    function handleCreateAttachmentNotification(
        notification: NotificationPayloadBase,
        parentItemId: ClientItemId,
        attachmentId: ClientAttachmentId,
        attachment: AttachmentType,
        attachmentState: AttachmentState,
        onSuccess: (attachmentType: AttachmentType) => void,
        onFailure: (error: Error) => void,
        dependencies: CreateAttachmentDependencies
    ): void {
        const payload: CreateAttachmentNotificationPayload = notification;

        try {
            if (payload.ResultCode === AttachmentResultCode.Success) {
                const responseMessage: AttachmentInfoResponseMessage =
                    payload.Response.ResponseMessages.Items[0];
                if (responseMessage && responseMessage.Attachments.length > 0) {
                    stopFakeProgressIndicator(attachmentState.attachmentId, true);
                    onSuccess(responseMessage.Attachments[0]);
                    onAttachmentCreationSuccess(
                        attachmentState,
                        attachmentId,
                        attachment,
                        responseMessage.Attachments[0],
                        parentItemId,
                        payload.Response.SharingInformation,
                        dependencies.attachmentWellViewState
                    );
                    return;
                }
            } else {
                throw new Error(
                    `ResultCode:${payload.ResultCode}, Id:${payload.Id}, Exception: ${payload.Exception}`
                );
            }
        } catch (error) {
            trace.errorThatWillCauseAlert(
                'Error handling the create attachment notification: ' + error
            );
        }

        stopFakeProgressIndicator(attachmentState.attachmentId, false);
        onFailure(new Error(payload.Exception));
        onAttachmentCreationError(
            attachmentState,
            dependencies.attachmentWellViewState,
            null,
            null
        );
    }
);
